import { useEffect, useSyncExternalStore } from "react";

/**
 * Whether the new frame is on screen. Today's app-wide extras (the trial box, the full-screen "trial is now active" screen,
 * the floating Terms & Privacy pill) are mounted outside every layout, so they ask this to stay out of the new pages.
 * A counter, not a flag: a remount (React strict mode, a frame swap) never leaves it wrong.
 */
let mounted = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };

export const isNextFrameMounted = () => mounted > 0;

/** Called once by NextFrame. Also puts `cy-next-frame` on <body>, for today's CSS that cannot use a hook. */
export const useMarkNextFrameMounted = () => {
  useEffect(() => {
    mounted += 1;
    document.body.classList.add("cy-next-frame");
    emit();
    return () => {
      mounted -= 1;
      if (mounted === 0) document.body.classList.remove("cy-next-frame");
      emit();
    };
  }, []);
};

export const useNextFrameMounted = (): boolean => useSyncExternalStore(subscribe, isNextFrameMounted, () => false);
